import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { FACEBOOK_MAKER_PIXEL_ID } from "@faire/web-api--source/indigofair/settings/FACEBOOK_MAKER_PIXEL_ID";

export const getSettingFacebookMakerPixelId = (): string => {
  return getSettingValueWithoutAssignment(FACEBOOK_MAKER_PIXEL_ID, "");
};
